// extracted by mini-css-extract-plugin
module.exports = {"privacyPolicy":"styles_privacyPolicy__3ewO7","privacyPolicy__text":"styles_privacyPolicy__text__Jr5aB","privacyPolicy__backButton":"styles_privacyPolicy__backButton__28_ek"};